<template>
  <b-form-group
    :id="`period-budget-${periodIndex}-fieldset`"
    :label-for="`period-budget-${periodIndex}-input`"
    label-class="form-label"
    class="mb-0"
  >
    <template
      v-if="periodIndex === 0"
      slot="label"
    >
      Period Budget (Gross) <span class="form-required">*</span>
    </template>
    <b-form-input
      :id="`period-budget-${periodIndex}-input`"
      :ref="`period-budget-${periodIndex}-input`"
      :value="getBudgetValue"
      @input="updateBudgetValue"
      @keydown.110.capture.prevent.stop
      :data-test="`period-budget-${periodIndex}-input`"
      :disabled="GET_IS_CAMPAIGN_READONLY || isBudgetInputDisabled"
    />
  </b-form-group>
</template>
<script>
import { mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

import helper from '@/core/helper';

export default {
  name: 'PeriodBudget',
  props: {
    periodIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    initialBudget: {
      type: [Number, null],
      required: false,
      default: null,
    },
    hasPeriodEnded: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      newBudget: null,
    };
  },
  computed: {
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_CAMPAIGN_DRAFT,
      campaignTypes.GET_IS_CAMPAIGN_REVIEW,
      campaignTypes.GET_IS_NEW_CAMPAIGN,
      campaignTypes.GET_IS_CAMPAIGN_READONLY,
      campaignTypes.GET_SELECTED_CURRENCY,
    ]),
    getBudgetValue() {
      return `${this.GET_SELECTED_CURRENCY.symbolString}${(this.newBudget ?? this.initialBudget) ?? ''}`;
    },
    isBudgetInputDisabled() {
      return !(this.GET_IS_CAMPAIGN_DRAFT || this.GET_IS_CAMPAIGN_REVIEW) && this.hasPeriodEnded;
    },
  },
  methods: {
    updateBudgetValue: helper.debounce(async function updateBudgetValue(newValue) {
      this.newBudget = Number(newValue.replace(/[^\d]/g, ''));
      await this.$nextTick();
      this.$refs[`period-budget-${this.periodIndex}-input`].$el.value = this.getBudgetValue;
      this.$emit('updateBudget', this.newBudget);
    }, 500),
  },
};
</script>
